import React, { Component } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import './ImportClienteMassa.css'
import {
  PageHeader,
  Cnpj,
  Btn,
  ExcelModeloBuilder,
  ImportExcelFile,
  CustomCheckbox,
  CustomDropdown,
  CustomPanel,
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { saveClientsMassively } from '../../../../services/api/https/system/system.http'

class ImportClienteMassa extends Component {
  modeloExcel = [
    [
      'nomeFantasia',
      'razaoSocial',
      'cnpj(somente números)',
      'cod_ibge_cidade',
      'endereço',
      'bairro',
      'número',
      'faz-devolucao-parcial(0-Não, 1-Sim)',
      'ativo(0-Não, 1-Sim)',
      'cep',
      'telefone',
      'inscricao_estadual',
    ],
  ]

  modeloExcelCidadeUf = [
    [
      'nomeFantasia',
      'razaoSocial',
      'cnpj(somente números)',
      'cidade',
      'uf',
      'endereço',
      'bairro',
      'número',
      'faz-devolucao-parcial(0-Não, 1-Sim)',
      'ativo(0-Não, 1-Sim)',
      'cep',
      'telefone',
      'inscricao_estadual',
    ],
  ]

  state = {
    loading: true,
    clientes: [],
    type_model: { name: 'Modelo com cod_ibge_cidade', value: 1 },
    associarAoTp: true,
  }
  onBtnSalvarClicked = async () => {
    this.props.dispatch(showLoadingBox('Aguarde', 'Carregando...'))
    try {
      this.setState({ loading: true })
      const { clientes } = this.state
      if (clientes.length === 0) {
        throw new Error('Não existem Clientes para Importação')
      }
      const { associarAoTp } = this.state
      const selectedTp = this.props.selectedTp
      const message = await saveClientsMassively(
        clientes,
        this.state.type_model.value,
        selectedTp,
        associarAoTp,
      )
      this.props.dispatch(showMessageBox(message, null))
      this.setState({ loading: false, clientes: [] })
    } catch (error) {
      this.setState({ loading: false })
      this.props.dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      this.props.dispatch(hideLoadingBox())
    }
  }
  onBtnVoltarClicked = () => {
    this.props.history.goBack()
  }
  onFileImported = content => {
    try {
      const isPlanilhaNoPadrao =
        this.state.type_model.value === 1
          ? this._planilhaNoPadrao(content)
          : this._planilhaNoPadraoCidadeUf(content)
      if (!isPlanilhaNoPadrao) {
        throw new Error('Planilha Fora do Padrão. Baixe o Modelo e Verifique.')
      }
      this.setState({ clientes: this._buildClientes(content) })
    } catch (error) {
      this.props.dispatch(showMessageBox(null, error.message))
    }
  }
  returnOnlyNumbers(value) {
    return value ? value.toString().replace(/\D/g, '') : null
  }
  render() {
    return (
      <div>
        <PageHeader>
          <span>S.7 - Importação de Clientes em Massa</span>
        </PageHeader>
        <div style={{ marginTop: 20 }}>
          <CustomPanel showBtnNovo={false} onVoltar={this.onBtnVoltarClicked}>
            <div className="p-grid" style={{ marginBottom: 15 }}>
              <div className="p-col-12" style={{ paddingTop: 25 }}>
                <div style={{ width: 240, display: 'inline-block', marginRight: 15 }}>
                  <CustomDropdown
                    label={'Tipo de Modelo de Importação'}
                    optionLabel={'name'}
                    options={[
                      { name: 'Modelo com cod_ibge_cidade', value: 1 },
                      { name: 'Modelo com Cidade e UF', value: 2 },
                    ]}
                    onChange={value => this.setState({ type_model: value })}
                    value={this.state.type_model}
                  />
                </div>
                <ExcelModeloBuilder
                  modeloColunas={
                    this.state.type_model.value === 1 ? this.modeloExcel : this.modeloExcelCidadeUf
                  }
                  filename="ImportacaoClientes.xlsx"
                />
                <div style={{ display: 'inline-block', marginLeft: 10 }}>
                  <ImportExcelFile
                    label="Importar"
                    classes="btnImportar"
                    onFileImported={this.onFileImported}
                  />
                </div>
                <div style={{ display: 'inline-block', marginLeft: 10 }}>
                  <Btn onClick={this.onBtnSalvarClicked}>Salvar</Btn>
                </div>
                <div style={{ display: 'inline-block', marginLeft: 15, verticalAlign: 'middle' }}>
                  <CustomCheckbox
                    checked={this.state.associarAoTp}
                    onChange={checked => this.setState({ associarAoTp: checked })}
                  >
                    Associar Clientes ao TP selecionado
                  </CustomCheckbox>
                </div>
              </div>
            </div>
            <div>
              <DataTable emptyMessage="Nenhum Registro Encontrado" value={this.state.clientes}>
                <Column field="nomeFantasia" header="Nome Fantasia" />
                <Column field="razaoSocial" header="Razão Social" />
                <Column
                  field="cnpj"
                  style={tableCellCentered(130)}
                  header="CNPJ"
                  body={cliente => <Cnpj>{cliente.cnpj}</Cnpj>}
                />
                {this.state.type_model.value === 1 ? (
                  <Column field="city_id" style={tableCellCentered()} header="City - IBGE" />
                ) : (
                  <Column field="city" style={tableCellCentered()} header="Cidade" />
                )}
                {this.state.type_model.value === 1 ? null : (
                  <Column field="uf" style={tableCellCentered(60)} header="UF" />
                )}
                <Column field="address" header="Endereço" />
                <Column field="district" header="Bairro" style={tableCellCentered()} />
                <Column field="number" style={tableCellCentered(80)} header="Número" />
                <Column
                  field="makeParcialReturn"
                  style={tableCellCentered(80)}
                  header="Faz Devolução Parcial"
                  body={cliente => <CustomCheckbox disabled checked={cliente.makeParcialReturn} />}
                />
                <Column
                  field="actived"
                  style={tableCellCentered(80)}
                  header="Ativo"
                  body={cliente => <CustomCheckbox disabled checked={cliente.actived} />}
                />
                <Column field="cep" header="CEP" style={tableCellCentered()} />
                <Column field="phone" header="Telefone" style={tableCellCentered()} />
                <Column field="inscricao_estadual" header="IE" style={tableCellCentered()} />
              </DataTable>
            </div>
          </CustomPanel>
        </div>
      </div>
    )
  }
  // Helpers
  _planilhaNoPadrao = content => {
    const header = content[0]
    return (
      header[0] === 'nomeFantasia' &&
      header[1] === 'razaoSocial' &&
      header[2] === 'cnpj(somente números)' &&
      header[3] === 'cod_ibge_cidade' &&
      header[4] === 'endereço' &&
      header[5] === 'bairro' &&
      header[6] === 'número' &&
      header[7] === 'faz-devolucao-parcial(0-Não, 1-Sim)' &&
      header[8] === 'ativo(0-Não, 1-Sim)' &&
      header[9] === 'cep' &&
      header[10] === 'telefone' &&
      header[11] === 'inscricao_estadual'
    )
  }

  _planilhaNoPadraoCidadeUf = content => {
    const header = content[0]
    return (
      header[0] === 'nomeFantasia' &&
      header[1] === 'razaoSocial' &&
      header[2] === 'cnpj(somente números)' &&
      header[3] === 'cidade' &&
      header[4] === 'uf' &&
      header[5] === 'endereço' &&
      header[6] === 'bairro' &&
      header[7] === 'número' &&
      header[8] === 'faz-devolucao-parcial(0-Não, 1-Sim)' &&
      header[9] === 'ativo(0-Não, 1-Sim)' &&
      header[10] === 'cep' &&
      header[11] === 'telefone' &&
      header[12] === 'inscricao_estadual'
    )
  }

  _buildClientes = content => {
    const body = content.splice(1)

    if (this.state.type_model.value === 1) {
      return body.map(row => {
        return {
          nomeFantasia: row[0],
          razaoSocial: row[1],
          cnpj: this.returnOnlyNumbers(row[2]),
          city_id: row[3],
          address: row[4],
          district: row[5],
          number: row[6],
          makeParcialReturn: row[7] === 1,
          actived: row[8] === 1,
          longitude: null,
          latitude: null,
          cep: this.returnOnlyNumbers(row[9]),
          phone: this.returnOnlyNumbers(row[10]),
          inscricao_estadual: this.returnOnlyNumbers(row[11]),
        }
      })
    } else {
      return body.map(row => {
        return {
          nomeFantasia: row[0],
          razaoSocial: row[1],
          cnpj: this.returnOnlyNumbers(row[2]),
          city: row[3],
          uf: row[4],
          address: row[5],
          district: row[6],
          number: row[7],
          makeParcialReturn: row[8] === 1,
          actived: row[9] === 1,
          longitude: null,
          latitude: null,
          cep: this.returnOnlyNumbers(row[10]),
          phone: this.returnOnlyNumbers(row[11]),
          inscricao_estadual: this.returnOnlyNumbers(row[12]),
        }
      })
    }
  }
}
const mapStateToProps = ({ system }) => ({ selectedTp: system.selectedTp })
export default connect(mapStateToProps)(withRouter(ImportClienteMassa))
